import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { Toaster } from "sonner";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import OrgOnboarding from "./pages/OrgOnboarding";
import Assessment from "./pages/Assessment";
import GapRegister from "./pages/GapRegister";
import DataInventory from "./pages/DataInventory";
import ProcessingActivities from "./pages/ProcessingActivities";
import PurposeRegistry from "./pages/PurposeRegistry";
import NoticeGenerator from "./pages/NoticeGenerator";
import ConsentManager from "./pages/ConsentManager";
import RightsRequests from "./pages/RightsRequests";
import Grievances from "./pages/Grievances";
import RetentionRules from "./pages/RetentionRules";
import ChildrenData from "./pages/ChildrenData";
import Vendors from "./pages/Vendors";
import CrossBorderTransfers from "./pages/CrossBorderTransfers";
import SecurityControls from "./pages/SecurityControls";
import BreachCenter from "./pages/BreachCenter";
import CertInReporting from "./pages/CertInReporting";
import DPIA from "./pages/DPIA";
import SDFReadiness from "./pages/SDFReadiness";
import PolicyGenerator from "./pages/PolicyGenerator";
import DocumentRepository from "./pages/DocumentRepository";
import EvidenceVault from "./pages/EvidenceVault";
import AuditLogs from "./pages/AuditLogs";
import Reports from "./pages/Reports";
import Connectors from "./pages/Connectors";
import ConnectorDetail from "./pages/ConnectorDetail";
import DataDiscovery from "./pages/DataDiscovery";
import DiscoveryAgents from "./pages/DiscoveryAgents";
import UserManagement from "./pages/UserManagement";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import DataPrincipalPortal from "./pages/DataPrincipalPortal";
import ComplianceControls from "./pages/ComplianceControls";
import CompanyProfile from "./pages/CompanyProfile";
import WebsiteScanner from "./pages/WebsiteScanner";

function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function AppShell() {
  const location = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  return (
    <Layout>
      <div key={location.pathname}>
      <Routes>
        <Route index element={<Navigate to="/app/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="company-profile" element={<CompanyProfile />} />
        <Route path="website-scanner" element={<WebsiteScanner />} />
        <Route path="vapt" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="iso27001" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="onboarding" element={<OrgOnboarding />} />
        <Route path="assessment" element={<Assessment />} />
        <Route path="gaps" element={<GapRegister />} />
        <Route path="tasks" element={<Navigate to="/app/gaps" replace />} />
        <Route path="data-inventory" element={<DataInventory />} />
        <Route path="processing-activities" element={<ProcessingActivities />} />
        <Route path="purposes" element={<PurposeRegistry />} />
        <Route path="notices" element={<NoticeGenerator />} />
        <Route path="consents" element={<ConsentManager />} />
        <Route path="rights-requests" element={<RightsRequests />} />
        <Route path="grievances" element={<Grievances />} />
        <Route path="retention-rules" element={<RetentionRules />} />
        <Route path="deletion-tasks" element={<Navigate to="/app/retention-rules" replace />} />
        <Route path="children-data" element={<ChildrenData />} />
        <Route path="vendors" element={<Vendors />} />
        <Route path="cross-border" element={<CrossBorderTransfers />} />
        <Route path="security-controls" element={<SecurityControls />} />
        <Route path="breaches" element={<BreachCenter />} />
        <Route path="cert-in" element={<CertInReporting />} />
        <Route path="dpia" element={<DPIA />} />
        <Route path="sdf" element={<SDFReadiness />} />
        <Route path="policy-generator" element={<PolicyGenerator />} />
        <Route path="documents" element={<DocumentRepository />} />
        <Route path="evidence" element={<EvidenceVault />} />
        <Route path="evidence-vault" element={<EvidenceVault />} />
        <Route path="audit-logs" element={<AuditLogs />} />
        <Route path="compliance-controls" element={<ComplianceControls />} />
        <Route path="ai-assistant" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="reports" element={<Reports />} />
        <Route path="integrations" element={<Navigate to="/app/connectors" replace />} />
        <Route path="connectors" element={<Connectors />} />
        <Route path="connectors/:id" element={<ConnectorDetail />} />
        <Route path="data-discovery" element={<DataDiscovery />} />
        <Route path="discovery-agents" element={<DiscoveryAgents />} />
        <Route path="guide" element={<Navigate to="/app/dashboard" replace />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="notifications" element={<Notifications />} />
      </Routes>
      </div>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<DataPrincipalPortal />} />
            <Route path="/app/*" element={<RequireAuth><AppShell /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
